import { HttpApi } from "@effect/platform";
import { Configuration, Products, Retention } from "./groups";
export const Api = HttpApi.make("open-revenue-dash-api").add(Products.ProductsApi).add(Configuration.ConfigurationApi).add(Retention.RetentionApi);
